import styled from 'styled-components';

export const ContainerLoja = styled.div`
  width: 100%;
  padding: 0 1.5rem;
`;

export const ContentLoja = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  padding: 20px 0;
  width: 100%;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const SettingsCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 1rem;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }
  svg {
    color: #3b82f6;
    font-size: 1.2rem;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
`;

export const DangerZone = styled(ToggleRow)`
  margin-top: 0.5rem;
  padding: 12px;
  border: 1px solid #fecaca;
  background-color: #fef2f2;
  border-radius: 8px;

  .info {
    label {
      color: #b91c1c;
      display: flex;
      align-items: center;
    }
    span {
      color: #ef4444;
    }
  }
`;
